import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const MenuIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 40 30", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("g", { strokeWidth: "3", stroke: color, strokeLinecap: "round" },
            React.createElement("path", { d: "M1 1h38M1 15h38M1 29h23.52" }))));
};
export default MenuIcon;
//# sourceMappingURL=index.js.map